import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { SearchHistoryClockIcon } from '../../atoms/icons/search_history_clock_icon';
import SearchTitle from './search_title';
export const SearchLandingHistories = ({ histories, onClickHistory, onClearHistories }) => {
    return (React.createElement("section", null,
        React.createElement(SearchTitle, { onClickLink: onClearHistories, linkLabel: "\u3059\u3079\u3066\u524A\u9664" }, "\u23F0 \u691C\u7D22\u5C65\u6B74"),
        React.createElement("div", { className: css(styles.chips) }, histories.map((history) => (React.createElement("div", { key: history, className: css(styles.chip), onClick: () => onClickHistory(history) },
            React.createElement(SearchHistoryClockIcon, null),
            history))))));
};
const styles = StyleSheet.create({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        gap: 8,
    },
    chip: {
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: 4,
        background: Colors.CyanLightest,
        borderRadius: 4,
        padding: '4px 8px',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: '0.48px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },
});
